<template>
  <GModal @onclick-backdrop="handleClose">
    <div slot="header"></div>
    <div slot="body">
      <div class="share-experience">
        <div class="header-banner">
          <h2>Yuk, Tulis Review!</h2>
          <h5>
            Bagikan pengalamanmu dan dapatkan +20 SP
            <br />
            untuk setiap Shopper Review yang kamu bagikan!
          </h5>
        </div>
        <div class="body-wrapper">
          <div class="search-wrapper">
            <div class="input-search-header">
              <input
                v-model="searchKey"
                type="text"
                class="form-control"
                placeholder="What do you want to review"
                autocomplete="off"
                @focus="isSearching = true"
                @input="handleSearch"
              />
              <div v-if="isSearching && searchKey.length > 0" class="search-result-dropdown">
                <div v-if="isLoadingMoreProduct" class="loading-spinner">
                  <div class="spinner"></div>
                  <p>Loading...</p>
                </div>
                <div v-else-if="searchResults.length" class="suggestion-results">
                  <ul class="list-suggestion-products">
                    <li v-for="(prod, idx) in searchResults" :key="idx" @click="selectProduct(prod)">
                      <CardRecentlyBought
                        :review-data="prod"
                        inline-footer
                        :is-show-rating="false"
                        :show-write-review="false"
                        class="search-card-item"
                      />
                    </li>
                  </ul>
                </div>
                <div v-else-if="hasSearched && !searchResults.length" class="no-results-search">
                  <div class="no-results-icon">
                    <img src="/assets/img/no-result.svg" alt="no result" />
                  </div>
                  <p class="no-results-text">Maaf, tidak ada produk yang ditemukan</p>
                </div>
              </div>
            </div>
          </div>

          <!-- No Results -->
          <div v-if="recentlyBought.length === 0 && popularProducts.length === 0" class="no-results">
            <div class="no-results-icon">
              <img src="/assets/img/no-result.svg" alt="" />
            </div>
            <p class="no-results-text">Maaf, tidak ada produk yang ditemukan</p>
          </div>

          <!-- Products Container -->
          <div v-else class="products-container" @scroll.passive="handleScroll">
            <!-- Recently Bought Section -->
            <div v-if="recentlyBought.length > 0" class="product-section">
              <h4>Share Your Shopper Review</h4>
              <div class="product-list-wrapper">
                <CardRecentlyBought
                  v-for="(product, i) in recentlyBought"
                  :key="'recent-' + i"
                  :review-data="product"
                  inline-footer
                  :is-show-rating="false"
                  :show-write-review="false"
                  @write-review-clicked="handleClose"
                />
              </div>
            </div>

            <!-- Popular Products Section -->
            <div v-if="popularProducts.length > 0" class="product-section">
              <h4>Popular Products</h4>
              <div class="product-list-wrapper">
                <CardRecentlyBought
                  v-for="(product, i) in popularProducts"
                  :key="'popular-' + i"
                  :review-data="product"
                  inline-footer
                  :is-show-rating="true"
                  :show-write-review="false"
                  @write-review-clicked="handleClose"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </GModal>
</template>

<script>
import { get, last, debounce } from 'lodash';
export default {
  name: 'ModalShareExperience',
  components: {
    CardRecentlyBought: () => import('../../dashboard/snippet/card-recently-bought'),
  },
  data() {
    return {
      searchKey: '',
      isSearching: false,
      searchResults: [],
      hasSearched: false,
      skipRecentlyBought: 0,
      limitRecentlyBought: 10,
      hasMoreRecentlyBought: true,
      isLoadingMoreRecentlyBought: false,
      skipProduct: 0,
      limitProduct: 10,
      hasMoreProduct: true,
      isLoadingMoreProduct: false,
    };
  },
  computed: {
    isDesktop() {
      return this.$store.state.screen.isDesktop;
    },
    recentlyBought() {
      return this.$store.state.product.recentlyBought || [];
    },
    popularProducts() {
      const products = this.$store.state.product.trendingProductsPopup || [];
      // Deduplicate by product ID
      const uniqueProducts = Array.from(
        new Map(products.map((product) => [product._id || product.id, product])).values(),
      );
      return uniqueProducts;
    },
  },
  watch: {
    isDesktop: {
      handler(isDesktop) {
        if (!isDesktop) {
          this.$router.push('/review/add/');
          this.handleClose();
        }
      },
      immediate: true,
    },
  },
  created() {
    // Create debounced version of search
    this.debouncedSearch = debounce(this.performSearch, 500); // 500ms delay
  },
  mounted() {
    this.getTrendingProducts();
    this.getRecentBought();
  },
  beforeDestroy() {
    // Cancel pending debounced calls on component destroy
    if (this.debouncedSearch) {
      this.debouncedSearch.cancel();
    }
  },
  methods: {
    handleClose() {
      this.$store.commit('toggleModalGlobalState', { modalName: 'shareExperience' });
    },
    handleSearch() {
      if (!this.searchKey.trim()) {
        this.searchResults = [];
        this.hasSearched = false;
        return;
      }
      this.debouncedSearch();
    },
    performSearch() {
      if (!this.searchKey.trim()) {
        this.searchResults = [];
        this.hasSearched = false;
        return;
      }

      // First search in already loaded products (recentlyBought + trendingProducts)
      const key = new RegExp(this.searchKey, 'i');
      const allProducts = [...this.recentlyBought, ...this.popularProducts];
      const localResults = allProducts.filter(function (p) {
        const brandName = p.brand && p.brand.name ? p.brand.name : '';
        return key.test(p.name) || key.test(brandName);
      });

      // Then search in catalog API for additional results
      this.getProductsSearch(this.searchKey, localResults);
    },
    selectProduct(prod) {
      this.isSearching = false;
      this.searchKey = '';
      this.$router.push('/review/add/' + prod.id);
      this.handleClose();
    },
    getTrendingProducts() {
      this.$MS_SOCO_PUBLIC_API_URL
        .get(`/v2/products/featured/trending`, {
          params: {
            filter: {
              is_reviewed: true,
              exclude_reviewed_products: true,
            },
            section: 'TrendingProducts',
          },
        })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            let items = response.data.data;
            items = items
              .map((res) => {
                const price = get(res, 'default_combination.price', null) || get(res, 'combinations[0].price', 0);
                if (res.default_combination && !('is_wishlist' in res.default_combination)) {
                  res.default_combination.is_wishlist = false;
                }
                res.image = get(last(res.images || []), 'url', '');
                res.manufacturer_name = get(res, 'brand.name', '');
                res.product_name = get(res, 'name', '');
                res.price = price;
                res.combination_id =
                  res.default_combination && res.default_combination._id
                    ? res.default_combination._id
                    : get(res, 'combinations[0]._id', null);
                return res;
              })
              .filter(function (item) {
                return !item.is_reviewed;
              });
            this.$store.commit('setProductTrendingPopup', items);
          } else {
            this.$store.commit('setProductTrendingPopup', []);
          }
        })
        .catch((err) => {
          this.$store.commit('setProductTrendingPopup', []);
        });
    },
    getProductsSearch(search = '', localResults = []) {
      if (this.isLoadingMoreProduct || !this.hasMoreProduct) {
        return;
      }
      this.isLoadingMoreProduct = true;

      const params = {
        fields: 'id,images,brand,name,default_combination,combinations,is_reviewed',
        limit: this.limitProduct,
        skip: this.skipProduct,
      };

      // Add search filter if search query exists
      if (search) {
        params.filter = {
          $or: [
            {
              'brand.name': {
                $regex: String(search).toLowerCase(),
                $options: 'i',
              },
            },
            {
              name: {
                $regex: String(search).toLowerCase(),
                $options: 'i',
              },
            },
          ],
        };
      }

      this.$MS_CATALOG_API_URL
        .get(`/search`, { params })
        .then((response) => {
          if (response.status === 200 && response.data.data) {
            let items = response.data.data;
            items = items
              .map((res) => {
                const price = get(res, 'default_combination.price', null) || get(res, 'combinations[0].price', 0);
                if (res.default_combination && !('is_wishlist' in res.default_combination)) {
                  res.default_combination.is_wishlist = false;
                }
                res.image = get(last(res.images || []), 'url', '');
                res.manufacturer_name = get(res, 'brand.name', '');
                res.product_name = get(res, 'name', '');
                res.price = price;
                res.combination_id =
                  res.default_combination && res.default_combination._id
                    ? res.default_combination._id
                    : get(res, 'combinations[0]._id', null);
                return res;
              })
              .filter(function (item) {
                return !item.is_reviewed;
              });

            // Update search results if searching, otherwise update store
            if (search) {
              // Combine local results with API results and deduplicate
              const allResults = [...localResults, ...items];
              const uniqueResults = Array.from(
                new Map(allResults.map((product) => [product._id || product.id, product])).values(),
              );
              this.searchResults = uniqueResults;
              this.hasSearched = true;
            } else {
              this.hasMoreProduct = false;
            }
          } else {
            if (search) {
              // If API fails but we have local results, show them
              this.searchResults = localResults;
              this.hasSearched = true;
            } else {
              this.hasMoreProduct = false;
            }
          }
        })
        .catch(() => {
          if (search) {
            // If API fails but we have local results, show them
            this.searchResults = localResults;
            this.hasSearched = true;
          } else {
            this.hasMoreProduct = false;
          }
        })
        .finally(() => {
          this.isLoadingMoreProduct = false;
        });
    },
    getRecentBought(isLoadMore) {
      if (this.isLoadingMoreRecentlyBought || !this.hasMoreRecentlyBought) {
        return;
      }
      this.isLoadingMoreRecentlyBought = true;
      this.$MS_ORDER_API_URL
        .get('users/me/recently-bought', {
          params: {
            fields: 'id,images,brand,name,default_combination,combinations',
            limit: this.limitRecentlyBought,
            skip: this.skipRecentlyBought,
          },
        })
        .then((res) => {
          if (res.status == 200 && res.data.success) {
            const datas = ((res.data && res.data.data) || [])
              .map((item) => {
                const price = get(item, 'default_combination.price', null) || get(item, 'combinations[0].price', 0);
                item.image = get(last(item.images || []), 'url', '');
                item.manufacturer_name = get(item, 'brand.name', '');
                item.product_name = get(item, 'name', '');
                item.price = price;
                item.combination_id =
                  item.default_combination && item.default_combination._id
                    ? item.default_combination._id
                    : get(item, 'combinations[0]._id', null);
                return item;
              })
              .reverse()
              .filter(function (item) {
                return !item.is_reviewed;
              });
            if (isLoadMore) {
              this.$store.commit('appendRecentlyBought', datas);
            } else {
              this.$store.commit('setRecentlyBought', datas);
            }
            if (datas.length < this.limitRecentlyBought) {
              this.hasMoreRecentlyBought = false;
            } else {
              this.skipRecentlyBought += this.limitRecentlyBought;
            }
          } else {
            this.hasMoreRecentlyBought = false;
          }
        })
        .catch(() => {
          this.hasMoreRecentlyBought = false;
        })
        .finally(() => {
          this.isLoadingMoreRecentlyBought = false;
        });
    },
    handleScroll(e) {
      const bottomReached = e.target.scrollTop + e.target.clientHeight >= e.target.scrollHeight - 10;
      if (bottomReached) {
        this.getRecentBought(true);
      }
    },
  },
};
</script>

<style lang="scss">
.modal-dialog {
  width: max-content;
}

.modal-content {
  overflow: hidden;
  margin-top: 20px;
  margin-bottom: 20px;

  .modal-header,
  .modal-body {
    padding: 0 !important;
  }

  .share-experience {
    width: 536px;
    max-height: 638px;

    &.see-all {
      width: 736px;

      .body-wrapper {
        padding: 16px;

        > h5 {
          color: #716a68;

          span {
            font-weight: bold;
          }
        }

        > .product-list-wrapper {
          grid-template-columns: 1fr 1fr;
        }
      }
    }

    > .header-banner {
      display: flex;
      font-family: 'Lato', sans-serif;
      flex-direction: column;
      align-items: flex-start;
      padding: 20px 40px 50px;
      background-color: #f8aeb2;
      color: #b32656;
      background-image: url('/assets/img/banner-share-experience-v2.svg');
      background-repeat: no-repeat;
      background-size: contain;
      background-position: right;
      text-align: left;
      > h2 {
        color: #b32656 !important;
        font-size: 24px;
        letter-spacing: 0px;
      }

      > h5 {
        color: #ffffff !important;
        font-size: 16px;
      }

      > :first-child {
        font-weight: bold;
      }
    }

    > .body-wrapper {
      font-family: 'Lato', sans-serif;
      position: relative;
      padding: 24px 16px 16px;

      > h4 {
        font-weight: bold;
        margin-bottom: 12px;
        font-size: 14px;
        color: #09000066;
      }

      > .products-container {
        max-height: 370px;
        overflow-y: auto;
        margin-top: 24px;
        padding-bottom: 12px;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
          background: #d1d1d1;
          border-radius: 4px;

          &:hover {
            background: #b1b1b1;
          }
        }

        > .product-section {
          margin-bottom: 24px;

          &:last-of-type {
            margin-bottom: 0;
          }

          > h4 {
            font-weight: bold;
            margin-bottom: 12px;
            font-size: 14px;
            color: #09000066;
          }

          > .product-list-wrapper {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 8px;

            > .card-recently-bought {
              width: 100%;
              border: none;

              .footer-wrapper.inline {
                justify-content: flex-start !important;

                .card-recently-bought__review {
                  display: none !important;
                }
              }

              .rating-inline {
                border: none !important;
                padding: 0 !important;
                margin: 0 !important;
              }
            }
          }
        }
      }

      > .search-wrapper {
        position: absolute;
        top: -20px;
        left: 0;
        right: 0;
        display: flex;
        justify-content: center;
        z-index: 10;

        > .input-search-header {
          width: 85%;
          background-color: white;
          border-radius: 4px;
          position: relative;
        }

        .search-result-dropdown {
          position: absolute;
          top: calc(100% + 0px);
          width: 100%;
          background: #fff;
          box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
          max-height: 420px;
          overflow-y: auto;
          z-index: 100;

          .loading-spinner {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 20px;
            text-align: center;

            .spinner {
              width: 40px;
              height: 40px;
              border: 4px solid #f3f3f3;
              border-top: 4px solid #b32656;
              border-radius: 50%;
              animation: spin 1s linear infinite;
              margin-bottom: 12px;
            }

            p {
              font-size: 14px;
              color: #716a68;
              margin: 0;
            }
          }

          @keyframes spin {
            0% {
              transform: rotate(0deg);
            }
            100% {
              transform: rotate(360deg);
            }
          }

          .no-results-search {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            padding: 40px 20px;
            text-align: center;

            .no-results-icon {
              margin-bottom: 16px;

              img {
                width: 80px;
                height: 80px;
              }
            }

            .no-results-text {
              font-size: 14px;
              font-weight: 400;
              color: #716a68;
              margin: 0;
              line-height: 1.4;
            }
          }

          .list-suggestion-products {
            list-style: none;
            margin: 0;
            padding: 0;

            li {
              cursor: pointer;
              transition: all 0.2s ease;
              background-color: transparent;
              border-bottom: 1px solid #e5e5e5;

              &:hover {
                background-color: #fff6f8;
              }

              .product--inline-navbar {
                display: flex;
                align-items: center;
                gap: 10px;

                .product__image {
                  width: 58px;
                  height: 58px;
                  border-radius: 6px;
                  flex-shrink: 0;
                  background: #fafafa;
                  object-fit: contain;
                }

                .product__info {
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;
                  padding-left: 0 !important;

                  .product__brand {
                    font-size: 13px;
                    font-weight: 700;
                    text-transform: uppercase;
                    color: #111;
                    margin-bottom: 3px;
                    line-height: 1.1;
                  }

                  .product__name {
                    font-size: 13px;
                    color: #555;
                    line-height: 1.3;
                    max-width: 95%;
                    word-break: break-word;
                  }
                }

                .product__rating {
                  margin-top: 4px;
                }
              }

              .card-recently-bought.search-card-item {
                width: 100% !important;
                display: flex;
                align-items: center;
                box-sizing: border-box;
                gap: 10px;

                .card-recently-bought__image {
                  width: 58px !important;
                  height: 58px !important;
                  flex-shrink: 0;
                  border-radius: 6px;
                  overflow: hidden;
                  background: #fafafa;

                  img {
                    width: 100%;
                    height: 100%;
                    object-fit: contain;
                  }
                }

                .card-recently-bought__info {
                  flex: 1;
                  display: flex;
                  flex-direction: column;
                  justify-content: center;

                  .card-recently-bought__brand {
                    font-size: 13px;
                    font-weight: 700;
                    color: #111;
                    margin-bottom: 3px;
                    text-transform: uppercase;
                  }

                  .card-recently-bought__name {
                    font-size: 13px;
                    color: #555;
                    line-height: 1.3;
                    word-break: break-word;
                  }
                }
              }
            }

            li:last-child {
              margin-bottom: 0;
            }
          }

          &::-webkit-scrollbar {
            width: 6px;
          }

          &::-webkit-scrollbar-thumb {
            background: #ccc;
            border-radius: 3px;
          }
        }
      }

      > .product-list-wrapper {
        display: grid;
        grid-template-columns: 1fr 1fr;
        max-height: 370px;
        margin-top: 24px;
        padding-bottom: 12px;
        overflow-y: auto;

        &::-webkit-scrollbar {
          width: 6px;
        }

        &::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 4px;
        }

        &::-webkit-scrollbar-thumb {
          background: #d1d1d1;
          border-radius: 4px;

          &:hover {
            background: #b1b1b1;
          }
        }

        > .card-recently-bought {
          width: 100%;
          border: none;

          .footer-wrapper.inline {
            justify-content: flex-start !important;

            .card-recently-bought__review {
              display: none !important;
            }
          }

          .rating-inline {
            border: none !important;
            padding: 0 !important;
            margin: 0 !important;
          }
        }
      }
    }
  }
}
</style>
